import { createTranslations } from '@npco/common-utils-translations'

export const termsAndConditionsTranslations = createTranslations({
  allConditions:
    'By providing your TFN and clicking “Activate”, you have read and understood our {termsOfService}, {financialServicesGuide}, and {productDisclosureStatement}.',
  termsOfService: 'Terms of Service',
  financialServicesGuide: 'Financial Services Guide',
  productDisclosureStatement: 'Product Disclosure Statement',
})
